var React = require('react');

function IconMobileMenuLightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 4.5H23","stroke":"#F2E9DA","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M8 12.5L23 12.5","stroke":"#F2E9DA","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M1 20.5H23","stroke":"#F2E9DA","strokeWidth":"2","strokeLinecap":"round","key":2})]);
}

IconMobileMenuLightInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = IconMobileMenuLightInline;

IconMobileMenuLightInline.default = IconMobileMenuLightInline;
